import React from 'react';
import { VideoIcon } from './icons/VideoIcon';
const modules = [{
  title: 'MÓDULO 1 – BIENVENIDA Y BASES PROFESIONALES',
  lessons: ['Presentación de la instructora', 'Bienvenida al BB Lips Hidratación Profunda', 'Qué es el BB Lips y cómo funciona', 'Beneficios del BB Lips', 'Beneficios reales para el cliente', 'Estructura anatómica de los labios']
}, {
  title: 'MÓDULO 2 – HERRAMIENTAS, PRODUCTOS Y SEGURIDAD',
  lessons: ['Qué es y cómo usar el Dermapen', 'Productos que se aplican en BB Lips', 'Utensilios necesarios para el procedimiento', 'Bioseguridad y manejo profesional', 'Contraindicaciones (cuándo NO realizar el tratamiento)']
}, {
  title: 'MÓDULO 3 – PROCEDIMIENTO PASO A PASO (PRÁCTICA REAL)',
  lessons: ['Procedimiento completo BB Lips paso a paso', 'Cuántas sesiones se necesitan', 'Práctica guiada paso a paso', 'Preparación y test de la modelo', 'Desinfección y limpieza correcta del labio', 'Aplicación y remoción de anestesia', 'Aplicación con vaselina', 'Cómo colocar y remover el algodón correctamente']
}, {
  title: 'MÓDULO 4 – TÉCNICA, COLOR Y CALIBRACIÓN',
  lessons: ['Selección del color para BB Lips', 'Selección correcta de la aguja', 'Calibración del Dermapen', 'Uso profesional del Dermapen', 'Aplicación del color paso a paso', 'Aplicación de agua destilada', 'Aplicación de la capa de color']
}, {
  title: 'MÓDULO 5 – FINALIZACIÓN Y RESULTADOS',
  lessons: ['Finalización del procedimiento', 'Cuidados después del tratamiento', 'Resultado real a las 24 horas', 'Recomendaciones para mejores resultados']
}];
export function CourseModules() {
  return <section id="contenido" className="py-12 px-4 bg-white" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <div className="text-center mb-10 space-y-3" data-id="element-18">
          <div className="inline-flex items-center gap-2 text-[#E5A5A0] mb-1" data-id="element-19">
            <VideoIcon className="w-4 h-4" data-id="element-20" />
          </div>
          <h2 className="text-2xl md:text-3xl font-semibold text-[#3D3028]" data-id="element-21">
            MÁS DE 30 LECCIONES EN VIDEO – PASO A PASO
          </h2>
          <p className="text-sm md:text-base text-[#3D3028]/70 max-w-2xl mx-auto" data-id="element-22">
            Accedés a una capacitación audiovisual completa, organizada en
            módulos claros y fáciles de seguir.
          </p>
        </div>

        <div className="space-y-4" data-id="element-23">
          {modules.map((module, moduleIndex) => <div key={moduleIndex} className="bg-[#FAF8F4] rounded-xl overflow-hidden border border-[#D4C4B0]/20" data-id="element-24">
              <div className="bg-[#3D3028] px-6 py-3" data-id="element-25">
                <h3 className="text-[#FAF8F4] font-medium text-xs md:text-sm tracking-wide" data-id="element-26">
                  {module.title}
                </h3>
              </div>
              <div className="p-6" data-id="element-27">
                <ul className="grid md:grid-cols-2 gap-3" data-id="element-28">
                  {module.lessons.map((lesson, lessonIndex) => <li key={lessonIndex} className="flex items-start gap-2" data-id="element-29">
                      <VideoIcon className="w-3.5 h-3.5 text-[#E5A5A0] mt-0.5 flex-shrink-0" data-id="element-30" />
                      <span className="text-[#3D3028]/80 text-xs md:text-sm leading-snug" data-id="element-31">
                        {lesson}
                      </span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}